module.exports = __webpack_public_path__ + "img/WP2023-Dubai2.a153c2fe.jpg";